import BlogPostIntro from '../blog_posts/BlogPostIntro';
import ParagraphDark from '../UI/ParagraphDark';
import SectionHeader from '../UI/SectionHeader';

const BlogSection = props => {
    return (
        <section id="section-blog-posts">
            <SectionHeader text={'Blog Posts'} headerGradientStyle={'header-blog-posts'} class={'mt-24 lg:mt-20'} />
            <BlogPostIntro
                blogTitle={'Generate and test RESTful APIs in Swift'}
                bgImage={'bg-blog-post'}
                linkHashnode={'https://blog.eidinger.info/generate-and-test-restful-apis-in-swift'}
                linkDevto={'https://dev.to/colocodes/hammering-down-react-basics-with-a-paint-coat-of-material-ui-o0h'}>
                <ParagraphDark>
                    <p>Don't spend hours writing code for a client API to interact with a server. Writing such code is tedious and repetitive if you support various clients in different programming languages.</p>
                </ParagraphDark>
                <ParagraphDark>
                    <p>Don't wait to start developing against a service that may not yet exist or for which you are waiting to get access.</p>
                </ParagraphDark>
                <ParagraphDark>
                    <p>You can create a fully functional client API and test it with a mocked backend literally in minutes with the help of some excellent open-source tools!  (...)</p>
                </ParagraphDark>
            </BlogPostIntro>
            <div class="divider w-1/2 mx-auto opacity-20"></div>
            <BlogPostIntro
                blogTitle={'Develop GitHub Actions with Swift'}
                bgImage={'bg-blog-post'}
                linkHashnode={'https://blog.eidinger.info/develop-github-actions-with-swift'}
                linkDevto={'https://dev.to/colocodes/2-use-cases-of-the-usereducer-reactjs-hook-ine'}>
                <ParagraphDark>I am an avid fan and user of GitHub Actions. Actions are individual tasks that you can combine to create jobs and customize your CI/CD workflow.</ParagraphDark>
                <ParagraphDark>You can write your own actions to use in your workflow and share those actions with the GitHub community. (...)</ParagraphDark>
            </BlogPostIntro>
            <div class="divider w-1/2 mx-auto opacity-20"></div>
            <BlogPostIntro
                blogTitle={'Master GitHub markdown tables with multi-line code blocks'}
                bgImage={'bg-blog-post'}
                linkHashnode={'https://blog.eidinger.info/master-github-markdown-tables-with-multi-line-code-blocks'}
                linkDevto={'https://dev.to/colocodes/5-use-cases-of-the-usestate-reactjs-hook-4n00'}>
                <ParagraphDark>Do you want to show a table with a multi-line code block on GitHub?</ParagraphDark>
                <ParagraphDark>Then follow these golden rules: (...)</ParagraphDark>
            </BlogPostIntro>
            <div class='block mx-auto mt-20 text-center'>
                <a href='https://blog.eidinger.info/' target='_blank' rel='noreferrer' class='btn'>Read more articles</a>
            </div>
        </section>
    );
};

export default BlogSection;
